import { makeStyles } from '@material-ui/core';

export const useImageStyles = makeStyles((theme) => ({
  image: (props) => ({
    width: props.width ? props.width : '100%',
  }),
}));
